import React /*, { Component }*/ from "react";
import PropTypes from "prop-types";
import {
    DropDownList,
    AutoComplete,
    MultiSelect,
    ComboBox,
} from "@progress/kendo-react-dropdowns";
import hasData from "../hoc/hasData";
import localize from "../hoc/localize";
import { compose } from "redux";
import {
    getMonthsForLast2Years,
    isEmpty,
    queryStringBuilder,
    getMonths,
} from "../helpers";
import { AppContext } from "../context/AppContext";
import { filterBy } from "@progress/kendo-data-query";

const qs = require("query-string");

class DropDownContainer extends React.Component {
    static propTypes = {
        dataType: PropTypes.oneOf([
            "adminVendors", // all vendors that are attachable to an org
            "vendors", // all vendors attached to the current user's org
            "majorVendors", // a list of all major vendors
            "dealerships", // all dealerships hierarchically beneath the current user's org
            "reportGroups", // all report groups attached to current user's org
            "partStatuses", // all possible part statuses
            "partGroups", // all possible part groups
            "orgTypes", // all possible org types
            "countries", // all possible countries
            "allOrgs", // all orgs in our system
            "allHierarchyOrgs", // all orgs hierarchy, including the current org.
            //"allParentableOrgs", // all orgs in our system that are parentable (i.e. capable of being parents of other orgs; i.e. dealergroup or higher)
            "roles", // all possible roles
            "states", // all possible states, filtered by country
            "languages", // all possible languages
            "currencies", // all possible currencies
            "timeZones", // all possible timezones
            "adjustmentReasons", // all possible reasons for changing a suggested order
            "orderTypes", // all possible suggested order types. 0: all; 1: GM; 2: P&A
            "exceptions", // all possible exceptions. 0: all; 1: Never Order; 2: Stocking Min/Max
            "monthYears", // month/year listings for the past two years
            "months", // month listing
            "partCategories", // all vendor categories
        ]).isRequired,

        mode: PropTypes.oneOf(["dropdownlist", "autocomplete", "multiselect", "combobox"]),

        // if getting list of all orgs, this prop allows us to exclude certain orgIDs from the results
        excludedOrgIDs: PropTypes.number,

        // if getting list of all orgs, this props lets us filter by minimum orgTypeID
        // gets all orgs that are at the same level as or higher than the provided orgTypeID
        // (see SOM.OrgType for dictionary)
        minOrgTypeID: PropTypes.number,

        // fired whenever we change the selected value in the dropdown
        handleChange: PropTypes.func.isRequired,

        // indicates whether you want to have a blank option.
        // this would allow the user to de-select the currently chosen value.
        // set to TRUE by default.
        hasEmptyOption: PropTypes.bool,

        // if looking up a list of vendors, you can look up the vendors under a particular orgID if desired
        orgID: PropTypes.number,
        reportGroupID: PropTypes.string,

        uiLanguage: PropTypes.string,

        defaultValue: PropTypes.object,

        // if looking up a list of states or orgs, can filter them based on countryID
        countryID: PropTypes.number,

        // if looking up a list of orgs, can filter them based on orgTypeID
        orgTypeID: PropTypes.number,

        // indicates if you want to default the value to the first item in the list (whenever the data finishes loading up).
        // this will only be honoured if nothing has been passed in through the "value" prop.
        defaultToFirstItem: PropTypes.bool,

        // callback function to fire once the data has been fully loaded up
        onAfterDataLoad: PropTypes.func,
    };
    state = {
        data: [],

        // a copy of this.state.data
        // we keep a copy of the original data since this.state.data may get mutated through filtering in the MultiSelect control
        // this way, once all the filters have been cleared out, we can go back to this original data set
        originalData: [],
        labelColumnName: "",
        idColumnName: "",
    };

    //constructor(props) {
    //    super(props);
    //}

    // trigger another retrieval of the data under certain conditions:
    // - it's a states dropdown and the countryID has changed
    // - it's an allOrg dropdown and the minOrgTypeID, and/or countryID and/or orgTypeID have changed
    // - it's a majorVendors dropdown and (the orgID or reportGroupID) have changed
    // - it's a vendors dropdown and the orgID have changed (for dealergroup user)
    componentDidUpdate(prevProps) {
        const { dataType } = this.props;
        if (
            (dataType === "states" &&
                prevProps.countryID !== this.props.countryID) ||
            (dataType === "allOrgs" &&
                (prevProps.minOrgTypeID !== this.props.minOrgTypeID ||
                    prevProps.countryID !== this.props.countryID ||
                    prevProps.orgTypeID !== this.props.orgTypeID)) ||
            (dataType === "majorVendors" &&
                (prevProps.orgID !== this.props.orgID ||
                    prevProps.reportGroupID !== this.props.reportGroupID)) ||
            (dataType === "vendors" && prevProps.orgID !== this.props.orgID) ||
            prevProps.uiLanguage !== this.props.uiLanguage
        ) {
            // if the countryID has changed, then we need to do another data pull
            this.getData(prevProps.value);
        }

        //console.log(prevProps)
    }

    componentDidMount() {
        const { defaultToFirstItem, mode } = this.props;

        const { data, labelColumnName, idColumnName } = this.state;

        let value = this.props.value;
        //console.log(data)
        if (!isEmpty(data)) {
            if (isEmpty(value)) {
                if (defaultToFirstItem) {
                    value = data[0];
                    switch (mode) {
                        case "dropdownlist":
                            this.handleChange({
                                target: { name: this.props.name, value: value },
                            });
                            break;
                        case "combobox":
                        case "multiselect":
                            if (labelColumnName && idColumnName) {
                                this.handleMultiSelectChange({
                                    target: {
                                        name: this.props.name,
                                        value: value,
                                    },
                                });
                            }
                            break;
                        case "autocomplete":
                            if (labelColumnName) {
                                this.handleChange({
                                    target: {
                                        name: this.props.name,
                                        value: value,
                                    },
                                });
                            }
                            break;

                        default:
                            break;
                    }
                }
            }
            //else {
            //    if (labelColumnName) {
            //        let index = data.findIndex(
            //            d => d[labelColumnName] === value[labelColumnName]
            //        );
            //        if (index > 0) {
            //            value = data[index];

            //            //switch (mode) {
            //            //    case "dropdownlist":
            //            //        this.handleChange({ target: { name: this.props.name, value: value } });
            //            //        break;
            //            //    case "multiselect":
            //            //        if (labelColumnName && idColumnName) {
            //            //            this.handleMultiSelectChange({ target: { name: this.props.name, value: value } });
            //            //        }
            //            //        break;
            //            //    case "autocomplete":
            //            //        if (labelColumnName) {
            //            //            this.handleChange({ target: { name: this.props.name, value: value } });
            //            //        }
            //            //        break;
            //            //    default:
            //            //        break;
            //            //}
            //        }
            //        else if (defaultToFirstItem) {
            //            value = data[0];

            //            //switch (mode) {
            //            //    case "dropdownlist":
            //            //        this.handleChange({ target: { name: this.props.name, value: value } });
            //            //        break;
            //            //    case "multiselect":
            //            //        if (labelColumnName && idColumnName) {
            //            //            this.handleMultiSelectChange({ target: { name: this.props.name, value: value } });
            //            //        }
            //            //        break;
            //            //    case "autocomplete":
            //            //        if (labelColumnName) {
            //            //            this.handleChange({ target: { name: this.props.name, value: value } });
            //            //        }
            //            //        break;
            //            //    default:
            //            //        break;
            //            //}
            //        }
            //    }
            //}
        }
        this.getData();
    }

    // load up the data
    //!DBTRANS! @m0565@ All Exceptions !DEVNOTE! Option Label
    //!DBTRANS! @m0566@ Never Order !DEVNOTE! Option Label
    //!DBTRANS! @m0567@ Stocking Min/Max !DEVNOTE! Option Label
    //!DBTRANS! @m0568@ Season !DEVNOTE! Option Label
    getData = (oldValue) => {
        // get the appropriate data
        let endpoint = "";
        let labelColumnName = "";
        let idColumnName = "";

        if (this.props.dataType === "partGroups") {
            this.setState(
                {
                    data: [
                        {
                            partGroupName:
                                this.props.returnLocalizedString("m0438"),
                            partGroupID: "",
                        },
                        {
                            partGroupName:
                                this.props.returnLocalizedString("m0437"),
                            partGroupID: "PA",
                        },
                        {
                            partGroupName:
                                this.props.returnLocalizedString("m0436"),
                            partGroupID: "GM",
                        },
                    ],
                    labelColumnName: "partGroupName",
                    idColumnName: "partGroupID",
                },
                () => {
                    if (this.props.value) {
                        let i = this.state.data.findIndex(
                            (element) =>
                                element.partGroupID ===
                                this.props.value.partGroupID
                        );

                        this.handleChange({
                            target: {
                                name: this.props.name,
                                value: this.state.data[i],
                            },
                        });
                    }
                }
            );
            return;
        } else if (this.props.dataType === "orderTypes") {
            this.setState(
                {
                    data: [
                        {
                            orderTypeID: 0,
                            orderType:
                                this.props.returnLocalizedString("m0438"),
                        },
                        {
                            orderTypeID: 1,
                            orderType:
                                this.props.returnLocalizedString("m0437"),
                        },
                        {
                            orderTypeID: 2,
                            orderType:
                                this.props.returnLocalizedString("m0436"),
                        },
                    ],
                    labelColumnName: "orderType",
                    idColumnName: "orderTypeID",
                },
                () => {
                    if (this.props.value) {
                        let i = this.state.data.findIndex(
                            (element) =>
                                element.orderTypeID ===
                                this.props.value.orderTypeID
                        );
                        this.handleChange({
                            target: {
                                name: this.props.name,
                                value: this.state.data[i],
                            },
                        });
                    }
                }
            );
            return;
        } else if (this.props.dataType === "exceptions") {
            this.setState(
                {
                    data: [
                        { exceptionID: -1, exception: "" }, // it means this filter is ignored
                        {
                            exceptionID: 0,
                            exception:
                                this.props.returnLocalizedString("m0565"),
                        },
                        {
                            exceptionID: 1,
                            exception:
                                this.props.returnLocalizedString("m0566"),
                        },
                        {
                            exceptionID: 2,
                            exception:
                                this.props.returnLocalizedString("m0567"),
                        },
                        {
                            exceptionID: 3,
                            exception:
                                this.props.returnLocalizedString("m0568"),
                        },
                        {
                            exceptionID: 4,
                            exception:
                                this.props.returnLocalizedString("m0575"),
                        },
                    ],
                    labelColumnName: "exception",
                    idColumnName: "exceptionID",
                },
                () => {
                    if (this.props.value) {
                        let i = this.state.data.findIndex(
                            (element) =>
                                element.exceptionID ===
                                this.props.value.exceptionID
                        );
                        this.handleChange({
                            target: {
                                name: this.props.name,
                                value: this.state.data[i],
                            },
                        });
                    }
                    //console.log(this.props);
                }
            );
            return;
        } else if (this.props.dataType === "monthYears") {
            const datepickerDates = getMonthsForLast2Years(
                this.props.getLanguage()
            );
            this.setState(
                {
                    data: datepickerDates,
                    labelColumnName: "date",
                    idColumnName: "dateID",
                },
                () => {
                    if (this.props.value) {
                        let i = this.state.data.findIndex(
                            (element) =>
                                element.dateID === this.props.value.dateID
                        );
                        this.handleChange({
                            target: {
                                name: this.props.name,
                                value: this.state.data[i],
                            },
                        });
                    }
                }
            );

            // try to see if there is a previously selected month/year; if not, then just grab the current month/year
            if (!this.context.state.selectedMonthYear) {
                this.context.setState({
                    selectedMonthYear:
                        datepickerDates[datepickerDates.length - 1],
                });
            }

            return;
        } else if (this.props.dataType === "months") {
            const months = getMonths(this.props.getLanguage());
            this.setState(
                {
                    data: months,
                    labelColumnName: "monthName",
                    idColumnName: "monthID",
                },
                () => {
                    if (this.props.value) {
                        let i = this.state.data.findIndex(
                            (element) =>
                                element.monthID === this.props.value.monthID
                        );
                        this.handleChange({
                            target: {
                                name: this.props.name,
                                value: this.state.data[i],
                            },
                        });
                    }
                }
            );
            return;
        }
        // else if (this.props.dataType === "adjustmentReasons") {
        //     this.setState({
        //         data: [
        //             { adjustmentReasonID: "", adjustmentReason: "", emptyOption: true },
        //             { adjustmentReasonID: 1, adjustmentReason: 'Out of season' },
        //             { adjustmentReasonID: 2, adjustmentReason: 'Hot season' },
        //             { adjustmentReasonID: 3, adjustmentReason: 'Obsolete item' },
        //             { adjustmentReasonID: 4, adjustmentReason: 'Invalid PKG setting' },
        //             { adjustmentReasonID: 5, adjustmentReason: 'Unrealistic to sell' },
        //             { adjustmentReasonID: 6, adjustmentReason: 'Have enough in stock' },
        //             { adjustmentReasonID: 7, adjustmentReason: 'Other' },
        //         ],
        //         labelColumnName: "adjustmentReason",
        //         idColumnName: "adjustmentReasonID"
        //     })
        //     return;
        // }

        const orgType = this.context.state.orgType;
        const vendor = this.context.state.selectedFilterVendor;
        let { countryID } = this.props;

        switch (this.props.dataType) {
            case "adjustmentReasons":
                endpoint = `/api/portal/adjustmentReason/GetList?uiLanguage=${this.props.uiLanguage}`;
                labelColumnName = "adjustmentReason";
                idColumnName = "adjustmentReasonID";
                break;
            case "roles":
                endpoint = "/api/portal/admin/role/GetList";
                labelColumnName = "role";
                idColumnName = "roleID";
                break;

            case "allOrgs":
                // get list of all orgs in the system
                endpoint = "/api/portal/admin/org/GetList";
                idColumnName = "orgID";
                labelColumnName = "orgName";

                let builder = new queryStringBuilder();

                const { excludedOrgIDs, minOrgTypeID, orgTypeID } = this.props;
                if (excludedOrgIDs)
                    builder.append("excludedOrgIDs", excludedOrgIDs);
                if (minOrgTypeID) builder.append("minOrgTypeID", minOrgTypeID);
                if (countryID) builder.append("countryID", countryID);
                if (orgTypeID) builder.append("orgTypeID", orgTypeID);

                endpoint += builder.queryString;
                break;

            // case "allParentableOrgs":
            //     // all orgs capable of being a parent of another org

            //     const { excludedOrgIDs, minOrgTypeID } = this.props;
            //     endpoint = "/api/portal/admin/org/GetList?parentable=true"
            //     if (!isEmpty(excludedOrgIDs)) {
            //         endpoint += `&excludedOrgIDs=${excludedOrgIDs}`
            //     }
            //     idColumnName = "orgID"
            //     labelColumnName = "orgName"

            //     break;
            case "allHierarchyOrgs":
                // get list of all orgs hierarchy, including the current org.
                endpoint = "/api/portal/admin/org/GetHierarchyList";
                idColumnName = "orgID";
                labelColumnName = "orgName";
                break;
            case "countries":
                // call /api/portal/admin/country/GetList
                // a list of all the countries we serve
                endpoint = "/api/portal/admin/country/GetList";
                idColumnName = "countryID";
                labelColumnName = "countryName";
                break;
            case "languages":
                endpoint = "/api/portal/admin/language/GetList";
                idColumnName = "languageID";
                labelColumnName = "languageName";
                break;
            case "currencies":
                endpoint = "/api/portal/admin/currency/GetList";
                idColumnName = "currencyID";
                labelColumnName = "currencyName";
                break;
            case "timeZones":
                endpoint = "/api/portal/admin/timezone/GetList";
                // idColumnName = "timeZoneName"
                // labelColumnName = "timeZoneName"
                idColumnName = null;
                labelColumnName = null;
                break;
            case "states":
                //let { countryID } = this.props;
                if (isEmpty(countryID)) {
                    countryID = 0;
                }
                endpoint = `/api/portal/admin/country/${countryID}/state/GetList`;
                idColumnName = "stateID";
                labelColumnName = "stateName";

                break;
            case "orgTypes":
                // a list of all the org types we have
                endpoint = "/api/portal/admin/org/GetOrgTypeList";
                idColumnName = "orgTypeID";
                labelColumnName = "orgType";

                break;
            case "majorVendors":
                endpoint = "/api/portal/majorVendor/GetList";
                idColumnName = "vendorID";
                labelColumnName = "vendorName";

                const { orgID, reportGroupID } = this.props;
                if (!isEmpty(orgID) || !isEmpty(reportGroupID)) {
                    const queryString = qs.stringify({
                        orgID,
                        reportGroupID,
                    });

                    endpoint += "?" + queryString;
                }

                break;
            case "vendors":
                // all vendors attached to the current user's org
                if (orgType === "dealer") {
                    endpoint = "/api/portal/vendor/GetList";
                } else {
                    // all vendors attached to a selected org
                    let orgID = this.props.orgID;
                    if (!orgID) orgID = 0;
                    endpoint = `/api/portal/vendor/${orgID}/GetList`;
                }

                labelColumnName = "vendorName";
                idColumnName = "orgVendorID";

                break;
            case "adminVendors":
                // get all vendors that could be attached to an org
                endpoint = `/api/portal/admin/vendor/GetList`;

                labelColumnName = "vendorName";
                idColumnName = "vendorID";
                break;

            case "dealerships":
                endpoint = "/api/portal/dealer/GetList";
                labelColumnName = "orgName";
                idColumnName = "orgID";
                break;
            case "reportGroups":
                endpoint = "/api/portal/reportGroup/GetList";
                labelColumnName = "reportGroupName";
                idColumnName = "reportGroupID";
                break;
            case "partStatuses":
                endpoint = "/api/portal/part/GetPartStatusList";
                labelColumnName = "partStatusName";
                idColumnName = "partStatusID";
                break;
            case "seasons":
                // all seasons attached to the current user's org
                if (orgType === "dealer") {
                    endpoint = `/api/portal/season/${this.context.state.orgID}`;
                } else {
                    // all seasons attached to a selected org
                    let orgID = this.props.orgID;
                    if (!orgID) orgID = 0;
                    endpoint = `/api/portal/season/${orgID}`;
                }

                labelColumnName = "seasonName";
                idColumnName = "seasonID";

                break;
            case "partCategories":
                endpoint = `/api/portal/partCategory/GetList?vendorID=${vendor.vendorID}&orgID=${this.context.state.selectedReportOrg.orgID}`;
                labelColumnName = "partCategoryName";
                idColumnName = "partCategoryID";
                break;
            default:
                break;
        }

        if (!isEmpty(endpoint)) {
            this.props
                .getData(endpoint)
                .then((response) => {
                    let data = response.data;

                    // add an empty element to front of array if necessary
                    // multiselect controls don't need the empty element; it's always blank by default
                    if (
                        this.props.hasEmptyOption &&
                        this.props.mode !== "multiselect"
                    ) {
                        if (labelColumnName && idColumnName) {
                            //debugger;

                            let emptyLabel = "";
                            let emptyId = "";

                            //!DBTRANS! @m0552@ All Vendors !DEVNOTE! Option Label
                            //!DBTRANS! @m0553@ All Adjustment Reasons !DEVNOTE! Option Label
                            //!DBTRANS! @m0554@ All Roles !DEVNOTE! Option Label
                            //!DBTRANS! @m0555@ All Orgs !DEVNOTE! Option Label
                            //!DBTRANS! @m0556@ All Countries !DEVNOTE! Option Label
                            //!DBTRANS! @m0557@ All Languages !DEVNOTE! Option Label
                            //!DBTRANS! @m0558@ All Currencies !DEVNOTE! Option Label
                            //!DBTRANS! @m0559@ All Time Zones !DEVNOTE! Option Label
                            //!DBTRANS! @m0560@ All States !DEVNOTE! Option Label
                            //!DBTRANS! @m0561@ All Org Types !DEVNOTE! Option Label
                            //!DBTRANS! @m0562@ All Dealerships !DEVNOTE! Option Label
                            //!DBTRANS! @m0563@ All Report Groups !DEVNOTE! Option Label
                            //!DBTRANS! @m0564@ All Part Status !DEVNOTE! Option Label
                            switch (this.props.dataType) {
                                case "adjustmentReasons":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0553"
                                        );
                                    emptyId = 0;
                                    break;
                                case "roles":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0554"
                                        );
                                    emptyId = "";
                                    break;
                                case "allOrgs":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0555"
                                        );
                                    emptyId = 0;
                                    break;
                                case "allHierarchyOrgs":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0555"
                                        );
                                    emptyId = 0;
                                    break;
                                case "countries":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0556"
                                        );
                                    emptyId = 0;
                                    break;
                                case "languages":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0557"
                                        );
                                    emptyId = 0;
                                    break;
                                case "currencies":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0558"
                                        );
                                    emptyId = 0;
                                    break;
                                case "timeZones":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0559"
                                        );
                                    emptyId = "";
                                    break;
                                case "states":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0560"
                                        );
                                    emptyId = 0;
                                    break;
                                case "orgTypes":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0561"
                                        );
                                    emptyId = 0;
                                    break;
                                case "majorVendors":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0552"
                                        );
                                    emptyId = 0;
                                    break;
                                case "vendors":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0552"
                                        );
                                    emptyId = "";
                                    break;
                                case "adminVendors":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0552"
                                        );
                                    emptyId = 0;
                                    break;
                                case "dealerships":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0562"
                                        );
                                    emptyId = 0;
                                    break;
                                case "reportGroups":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0563"
                                        );
                                    emptyId = "";
                                    break;
                                case "partStatuses":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0564"
                                        );
                                    emptyId = "";
                                    break;
                                case "partCategories":
                                    emptyLabel =
                                        this.props.returnLocalizedString(
                                            "m0606"
                                        );
                                    emptyId = "";
                                    break;

                                default:
                                    break;
                            }

                            data.unshift({
                                [labelColumnName]: emptyLabel,
                                [idColumnName]: emptyId,
                                emptyOption: false,
                            });
                            //data.unshift({
                            //    [labelColumnName]: emptyLabel,
                            //    [idColumnName]: emptyId,
                            //    emptyOption: true // this will be a flag to indicate that we've chosen the blank option from the dropdown
                            //});
                        } else {
                            data.unshift("");
                        }
                    }

                    let value = oldValue;

                    if (!isEmpty(data)) {
                        if (isEmpty(value)) {
                            if (this.props.defaultToFirstItem) {
                                value = data[0];
                                this.handleChange({
                                    target: {
                                        name: this.props.name,
                                        value: value,
                                    },
                                });
                            }
                        } else {
                            if (labelColumnName) {
                                let index = data.findIndex(
                                    (d) =>
                                        d[labelColumnName] ===
                                        value[labelColumnName]
                                );
                                if (index >= 0) {
                                    value = data[index];

                                    this.handleChange({
                                        target: {
                                            name: this.props.name,
                                            value: value,
                                        },
                                    });
                                } else if (this.props.defaultToFirstItem) {
                                    value = data[0];

                                    this.handleChange({
                                        target: {
                                            name: this.props.name,
                                            value: value,
                                        },
                                    });
                                }
                            }
                        }
                    }
                    this.setState(
                        {
                            data: response.data,
                            originalData: response.data,
                            labelColumnName,
                            idColumnName,
                        },
                        () => {
                            //this.props.onAfterDataLoad
                            if (this.props.value) {
                                //console.log(this.state.data);
                                let i = this.state.data.findIndex(
                                    (element) =>
                                        element[idColumnName] === this.props.value[idColumnName]
                                );
                                this.handleChange({
                                    target: {
                                        name: this.props.name,
                                        value: this.state.data[i],
                                    },
                                });
                            }
                        }
                    );
                })
                .catch((error) => {
                    //debugger;
                });
        }
    };

    // fired when user changes selection in DropDownList or AutoComplete
    handleChange = (e) => {
        // bubble up a "null" if the blank option was selected
        //debugger;

        let newValue = e.target.value;
        //if (newValue.emptyOption) {
        //    newValue = null;
        //}
        this.props.handleChange({
            target: { name: e.target.name, value: newValue },
        });
    };

    // fired when user changes selection in MultiSelect
    handleMultiSelectChange = (e) => {
        this.props.handleChange({
            target: { name: e.target.name, value: e.target.value },
        });
    };

    handleMultiSelectFilterChange = (e) => {
        const dataSet = this.state.originalData.slice();
        this.setState({
            data: filterBy(dataSet, e.filter),
        });
        //        this.props.handleChange({ target: { name: e.target.name, value: e.target.value } });
    };

    render() {
        // /debugger;
        const { mode } = this.props;

        const { data, labelColumnName, idColumnName } = this.state;

        let value = this.props.value;

        switch (mode) {
            case "dropdownlist":
                //console.log('this.props.dataType', this.props.dataType, labelColumnName, idColumnName);
                if (!isEmpty(data)) {
                    return (
                        <DropDownList
                            {...this.props}
                            value={value}
                            data={this.state.data}
                            {...(labelColumnName && idColumnName
                                ? {
                                    textField: labelColumnName,
                                    dataItemKey: idColumnName,
                                }
                                : undefined)}
                            onChange={this.handleChange}
                        />
                    );
                }
                break;
            case "multiselect":
                if (data && labelColumnName && idColumnName) {
                    // check if "filterable" = true
                    // if so, need to add some additional properties

                    let filterProps = {};
                    if (this.props.filterable) {
                        filterProps = {
                            filterable: true,
                            onFilterChange: this.handleMultiSelectFilterChange,
                        };
                    }

                    return (
                        <MultiSelect
                            {...this.props}
                            {...filterProps}
                            value={value}
                            dataItemKey={idColumnName}
                            textField={labelColumnName}
                            data={this.state.data}
                            onChange={this.handleMultiSelectChange}
                        />
                    );
                }
                break;
            case "autocomplete":
                if (data && labelColumnName && idColumnName) {
                    return (
                        <AutoComplete
                            {...this.props}
                            value={value}
                            data={this.state.data}
                            textField={labelColumnName}
                            
                            onChange={this.handleChange}
                        />
                    );
                }
                break;
            case "combobox":
                if (data && labelColumnName) {
                    return (
                        <ComboBox
                            {...this.props}
                            value={value}
                            data={this.state.data}
                            textField={labelColumnName}
                            dataItemKey={idColumnName}
                            onChange={this.handleChange}
                        />
                    );
                }
                break;
            default:
                break;
        }

        return <React.Fragment />;
    }
}
DropDownContainer.defaultProps = {
    hasEmptyOption: true,
    mode: "dropdownlist",
};

export default compose(localize, hasData)(DropDownContainer);
DropDownContainer.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/components/DropDownContainer.js